<fieldset>
  <div class="autocomplete-container" [style.width]="width" [class.readonly]="readonly">
    @if (!showBulkSearch) {
      <div class="header">
        @if (label) {
          <div class="label">{{ label }}</div>
        }

        @if (link && text && !readonly) {
          <div>
            <app-link [link]="link" [text]="text"></app-link>
          </div>
        } @else if (!readonly) {
          <app-form-switch-button
            [text]="switchBtnText"
            (switchForm)="onClickBtn()"
          ></app-form-switch-button>
        }
      </div>
    }

    <div
      class="input-wrapper"
      [class]="{
        error: searchFailed || displayValidationError,
        check: (status === AddressStatus.CHECKED) && displayStatus,
        warn: status === AddressStatus.WARNING,
        readonly
      }"
    >
      @if (showBulkSearch) {
        <i class="input-icon-left icon ic-search-20" [class]="{'text-gray600': !value, 'text-gray700': value}"></i>
      }

      <input
        #typeaheadInput
        type="text"
        class="input"
        [class]="{'bulk': showBulkSearch}"
        [value]="value"
        [ngbTypeahead]="search"
        [placeholder]="placeholder"
        [disabled]="isDisabled || disabled"
        (blur)="onBlurSearchControl($event)"
        (click)="autocompleteTrigger$.next()"
        (focus)="onFocusSearchControl($event)"
        (selectItem)="selectOption($event)"
        (keydown)="focusOnActiveOption($event, typeaheadInput)"
      />

      @if (searching || isValidating) {
        <i class="input-icon fad fa-spinner-third fa-spin"></i>
      } @else {
        <i
          class="input-icon icon"
          [class]="{
          'ic-info-circle-16': status === AddressStatus.WARNING || displayValidationError,
          'ic-checkmark-circle-16': status === AddressStatus.CHECKED && value,
          'bulk': showBulkSearch
        }">
        </i>
      }

      @if (showBulkSearch && searchTerm) {
        <i class="input-icon icon ic-close-16" (click)="clear()"></i>
      }
    </div>

    @if (status === AddressStatus.WARNING && !displayValidationError && !hideWarningMessage && !readonly) {
      <div class="helper">Address was not validated and most likely to be rejected</div>
    }

    @if (displayValidationError) {
      <app-validation-error
        [control]="control"
        [customErrors]="customErrors"
      />
    }
  </div>
</fieldset>
